import { store } from '../_store'

export default {
    // setUserCart(state, cart_items) {
    //     state.user.cart = [...state.user.cart, ...cart_items]
    // },

    setUser(state, user) {
        store.dispatch('doInitStore', user)
    },

    setAddToWishlist(state, product) {
        let product_to_add = [JSON.parse(JSON.stringify(product))]

        let product_to_update = state.user.wish_list.filter(item => {
            return product.sku == item.sku
        })

        if (product_to_update.length > 0) {
            state.user.wish_list = state.user.wish_list.map(item => {
                if (item.sku === product.sku) {
                    let clonnedObj = JSON.parse(JSON.stringify(item))
                    return clonnedObj
                } else {
                    return item
                }
            })
        } else {
            state.user.wish_list = [...state.user.wish_list, ...product_to_add]
        }
         
    },

    setRemoveFromWishlist(state, product) {
        state.user.wish_list = state.user.wish_list.filter(item => {
            return item.sku !== product.sku
        })
    },
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/mutations/usersMutations.js